import { render, staticRenderFns } from "./ProjectCatalogs.vue?vue&type=template&id=5849c48c"
import script from "./ProjectCatalogs.vue?vue&type=script&lang=ts"
export * from "./ProjectCatalogs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports